import { z } from 'zod';
import { optionalStringArray } from '../_shared/coerce.js';
/**
 * Valeur sentinelle du filtre « villes » : vaut toutes les villes que l'export
 * IGA rattache à la France, côté départ comme côté arrivée. Le serveur la
 * remplace par la liste réelle ; l'URL, elle, ne porte qu'un seul terme.
 *
 * Les doubles tirets bas la mettent hors d'atteinte d'un vrai nom de ville —
 * « FRANCE » en est un dans cette donnée, il ne pouvait donc pas servir.
 */
export const FRANCE_CITIES_VALUE = '__FRANCE__';
export const statisticsQuerySchema = z.object({
    activites: optionalStringArray(),
    classes: optionalStringArray(),
    dateRangeType: z.enum(['year', 'custom']).optional(),
    endDate: z.string().optional(), // Format: DD/MM/YYYY
    fournisseurs: optionalStringArray(),
    locationType: z.enum(['city', 'country', 'zone']).optional(),
    locationValue: optionalStringArray(),
    montantTtcMax: z.coerce.number().optional(),
    montantTtcMin: z.coerce.number().optional(),
    startDate: z.string().optional(), // Format: DD/MM/YYYY
    year: z.coerce.number().int().min(2000).max(2100).optional(),
});
